import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { View } from "@-/com.npmjs.react-native";
import type { PrimaryNavigationDestination } from "@-/dev.improve.haniverse.database.schemas.actor.schema._tables.user";
import { PRIMARY_NAVIGATION_DESTINATION_PRESENTATIONS } from "#primary-navigation-destination-presentations";

/**
 * A destination's icon on a liftable square: how strip icons look while the strip is edited, in
 * the Settings palette, and (lifted) under the finger.
 */
export function PrimaryNavigationDestinationChip({
  destination,
  variant = "palette",
}: {
  destination: PrimaryNavigationDestination;
  /** `strip` is the smaller chip that fits the strip's icon row; `lifted` rides under the finger. */
  variant?: "lifted" | "palette" | "strip";
}) {
  const { icon, iconSize } = PRIMARY_NAVIGATION_DESTINATION_PRESENTATIONS[destination];
  return (
    <View
      className={
        variant === "lifted"
          ? "size-11 items-center justify-center rounded-xs border border-primary bg-surface shadow-lg dark:border-foreground"
          : variant === "strip"
            ? "size-8 items-center justify-center rounded-xs border border-border bg-background"
            : "size-11 items-center justify-center rounded-xs border border-border bg-background"
      }
    >
      <Icon className="text-foreground" name={icon} size={iconSize} />
    </View>
  );
}
